import { createSlice } from "@reduxjs/toolkit";
import { ContextProvider } from "../../../../../common/providers";

const initialState = {
	tableHead: [],
	tableBody: [],
	currentTab: {},
	myPortfolios: [],
	rowsPerPage: 50,
	search: { uuidToValue: {} },
	sorting: {},
	filters: { projectStatus: "ACTIVE" },
	tableColumnOrder: ContextProvider.getPortfolioTableColumnOrder() || [],
};

const reconcileColumnOrder = (previousOrder, tableHead) => {
	if (!Array.isArray(tableHead)) {
		return previousOrder;
	}
	const headByKey = new Map(tableHead.map((cell) => [cell.fieldUuid, cell]));
	const kept = previousOrder
		.filter((col) => headByKey.has(col.key))
		.map((col) => ({ ...col, name: headByKey.get(col.key).name }));
	const keptKeys = new Set(kept.map((col) => col.key));
	const added = tableHead
		.filter((cell) => !keptKeys.has(cell.fieldUuid))
		.sort((a, b) => a.displayOrder - b.displayOrder)
		.map((cell) => ({ key: cell.fieldUuid, name: cell.name, visibility: true }));
	return [...kept, ...added];
};

const portfolioSpaceSlice = createSlice({
	name: "portfolioSpace",
	initialState,
	reducers: {
		resetAllFiltersPortfolioSpace: (state) => ({
			...state,
			search: { uuidToValue: {} },
			projectNameSearch: "",
			filters: { projectStatus: "ACTIVE" },
			sorting: {},
			tableHead: [],
		}),
		setTableHead: (state, { payload }) => {
			const tableColumnOrder = reconcileColumnOrder(state.tableColumnOrder, payload);
			ContextProvider.setPortfolioTableColumnOrder(tableColumnOrder);
			return { ...state, tableHead: payload, tableColumnOrder };
		},
		setTableBody: (state, { payload }) => ({
			...state,
			tableBody: payload,
		}),
		setRowsPerPage: (state, { payload }) => ({
			...state,
			rowsPerPage: payload,
		}),
		setCurrentTab: (state, { payload }) => ({
			...state,
			currentTab: payload,
		}),
		setMyPortfolios: (state, { payload }) => ({
			...state,
			myPortfolios: payload,
		}),
		setSearch: (state, { payload }) => ({
			...state,
			search: payload,
		}),
		setProjectNameSearch: (state, { payload }) => ({
			...state,
			projectNameSearch: payload,
		}),
		setSorting: (state, { payload }) => ({
			...state,
			sorting: payload,
		}),
		setFilters: (state, { payload }) => ({
			...state,
			filters: payload,
		}),
		setPortfolioTableColumnOrder: (state, { payload }) => {
			ContextProvider.setPortfolioTableColumnOrder(payload);
			return { ...state, tableColumnOrder: payload };
		},
	},
});

export const {
	resetAllFiltersPortfolioSpace,
	setTableHead,
	setTableBody,
	setRowsPerPage,
	setCurrentTab,
	setMyPortfolios,
	setSearch,
	setProjectNameSearch,
	setSorting,
	setFilters,
	setPortfolioTableColumnOrder,
} = portfolioSpaceSlice.actions;
export default portfolioSpaceSlice.reducer;
